var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"truckCtrl"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"chartBtn",attrs:{"title":_vm.tooltiptext}},[_vm._v(_vm._s(_vm.ganttChartVehicle.vehicleName)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }